























import Vue from 'vue';
import { Image } from './types';

export default Vue.extend({
  name: 'ImageChooser',
  props: {
    images: {
      type: Array as () => Image[] // https://stackoverflow.com/questions/41139763/how-to-declare-a-fixed-length-array-in-typescript
    },
    chosenId: {
      type: String,
      default: '1'
    }
    // Later change this to focusImages OR use dropdowns OR add modal
    // images: {
    //   type: [Image, Image, Image]
    // }
  },
  methods: {
    // set @left and @right, as well as @mainLeft and @mainRight
    setChosenId(id: string): void {
      this.$emit('setChosenId', id);
    }
  }
});
